import { ErrorProvider, setStorage, useUserContext } from '@acre/utils'

import type { RecentlyViewedCase } from '../../../pages/Cases/CaseDetails/CaseDetails.helpers'
import { formatCaseOption } from './GlobalSearchRecentCases.helpers'

export const useGetFormattedRecentCasesOptions = () => {
  const user = useUserContext()

  if (!user?.id) return []

  const storageKey = `${user.id}-recentlyViewedCases`
  const recentCases: RecentlyViewedCase[] = JSON.parse(localStorage.getItem(storageKey) || '[]')

  if (!recentCases.length) return []

  // Filter out incomplete case data that's missing required fields
  const validCasesFromLocalStorage = recentCases.filter((caseInput): caseInput is RecentlyViewedCase => {
    return Boolean(caseInput && caseInput.id && caseInput.status && caseInput.preference_mortgage_reason)
  })
 
  // Clean up localStorage if any incomplete cases were found
  if (validCasesFromLocalStorage.length !== recentCases.length) {
    setStorage(localStorage, storageKey, JSON.stringify(validCasesFromLocalStorage)).catch((err) => {
      ErrorProvider.showError(err)
    })
  }

  const formattedCases = validCasesFromLocalStorage.map((validCaseInput) => {
    return formatCaseOption(validCaseInput)
  })

  return formattedCases
}
